import React, { useState } from "react";
import "./FeedbackForm.css";
import { useTranslation } from 'react-i18next';

import Ratings from "./Ratings";

export default function FeedbackForm({ className }) {
    const { t, i18n } = useTranslation();
    const lang = i18n.language.split('-')[0];

    const [feedbackContent, setFeedbackContent] = useState('');
    const [rating, setRating] = useState(null);
    const [location, setLocation] = useState(null);
    const [showLocationWarning, setShowLocationWarning] = useState(false);

    const reviewLinks = {
        olhao: 'https://g.page/r/CUG699yo-fpKEBM/review',
        tavira: 'https://g.page/r/CTalkDU9y183EBM/review',
    };

    const submitLabels = {
        en: 'Submit Feedback',
        pt: 'Enviar Feedback',
        es: 'Enviar opinión',
        fr: 'Envoyer le commentaire'
    };

    const warnings = {
        en: 'Please select a location first.',
        pt: 'Por favor, selecione primeiro uma localização.',
        es: 'Por favor, selecciona primero una ubicación.',
        fr: "Veuillez d'abord sélectionner un emplacement."
    }

    const handleLocationChange = (value) => {
        setLocation(value);
        setRating(null);
        setFeedbackContent('');
        setShowLocationWarning(false);
    };

    const handleRatingChange = (e) => {
        if (location === null) {
            setShowLocationWarning(true);
            return;
        }
        const value = Number(e.target.value)
        setRating(value);
        setFeedbackContent('');
        if (value >= 4) {
            window.open(reviewLinks[location], '_blank');
        }
    };

    const handleFeedbackChange = (e) => {
        setFeedbackContent(e.target.value);
    };

    const handleRatingAttempt = () => {
        if (location === null) setShowLocationWarning(true);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const form = e.target;
        const formData = new FormData(form);

        // Spitting data directly to log
        const formJson = Object.fromEntries(formData.entries());
        console.log(formJson)
    };
    return (
        <div className={`form-container ${className ?? ''}`}>
            <p className="feedback-prompt">{t('feedback-prompt')}</p>
            <form method="post" onSubmit={handleSubmit}>
                <div className="location-toggle" role="group" aria-label="Select a location">
                    <button
                        type="button"
                        className={location === "tavira" ? "active" : ""}
                        onClick={() => handleLocationChange("tavira")}
                    >
                        Tavira
                    </button>
                    <button
                        type="button"
                        className={location === "olhao" ? "active" : ""}
                        onClick={() => handleLocationChange("olhao")}
                    >
                        Olhão
                    </button>
                </div>
                {showLocationWarning && (
                    <p className="location-warning">{warnings[lang] ?? warnings.en}</p>
                )}

                <label>
                    <Ratings
                        onChange={handleRatingChange}
                        disabled={location === null}
                        value={rating}
                        onDisabledClick={handleRatingAttempt}
                    />
                </label>

                <div
                    className={`feedback-textarea-wrapper ${rating !== null && rating <= 3 ? 'visible' : ''}`}
                    aria-hidden={rating === null || rating > 3}
                >
                    <label htmlFor="textFeedback">
                    {t('feedback')}
                    </label>
                    <textarea
                        id="textFeedback"
                        name="textFeedback"
                        rows={4} cols={30}
                        value={feedbackContent}
                        onChange={handleFeedbackChange}
                        maxLength={400}
                        tabIndex={rating !== null && rating <= 3 ? 0 : -1}
                    />
                    <button
                        className="submit-button"
                        type="submit"
                        tabIndex={rating !== null && rating <= 3 ? 0 : -1}
                    >
                        {submitLabels[lang] ?? submitLabels.en}</button>
                </div>
            </form>
        </div>
        
    );
}